import type { FeaturePageSeo } from "@/components/feature-template/seo";
import type { FAQItem } from "@/components/feature-template/types";

// Shared by page.tsx (JSON-LD) and the client page (visible FAQ) so both always match.

export const faqs: FAQItem[] = [
  {
    question: "What can Insider Connections write for me?",
    answer:
      "Cold emails to hiring managers and LinkedIn DMs for four goals: asking for an interview, building industry connections, expanding your network and following up.",
  },
  {
    question: "What information does it use?",
    answer:
      "The job role, company and job description you enter, plus your resume if you upload it. That lets each message mention a real achievement that matches what the team needs.",
  },
  {
    question: "Can it find a hiring manager's email?",
    answer:
      "Yes. Email Finder looks up a work email from a person's name and company domain, and shows whether the address is verified.",
  },
  {
    question: "Can I send emails from MindMyJob?",
    answer:
      "Yes. Cold emails can be sent directly from the app, or copied to send from your own inbox. LinkedIn DMs are copied to paste into LinkedIn.",
  },
  {
    question: "Will my LinkedIn DM fit the connection note limit?",
    answer:
      "Interview and connection DMs are written to stay short enough for a LinkedIn connection note, and the character count is shown before you copy.",
  },
  {
    question: "Can I see messages I sent before?",
    answer:
      "Yes. Message History keeps every email and DM you generate, filtered by channel, so you can reuse a strong message or send a follow-up.",
  },
  {
    question: "Is there a daily limit?",
    answer:
      "Each account has a daily number of generations, shown at the top of the generator so you always know how many are left.",
  },
];

export const seo: FeaturePageSeo = {
  slug: "insider-connections",
  name: "Insider Connections",
  title: "Cold Email & LinkedIn DM Writer for Job Seekers | MindMyJob",
  description:
    "Reach hiring managers directly. Write personalised cold emails and LinkedIn DMs from your resume and the job, find verified work emails and track every message.",
  keywords: [
    "cold email to hiring manager",
    "linkedin message to recruiter",
    "linkedin dm template job",
    "networking message generator",
    "find hiring manager email",
    "email finder for job search",
    "referral request message",
    "follow up message after application",
    "job search outreach",
    "ai networking assistant",
  ],
  ogImage: "/assets/images/features/insider-connections/hero-cold-email.png",
  ogImageAlt:
    "MindMyJob Insider Connections writing a personalised cold email to a hiring manager",
  featureList: [
    "Personalised cold emails to hiring managers",
    "LinkedIn DMs for four outreach goals",
    "Email Finder with verification",
    "Messages built from your resume and the job description",
    "Send email directly or copy",
    "Message history",
  ],
  faqs,
};
